import React from 'react';
import { Svg } from 'app/components/common';
import CustomImage from 'app/components/common/CustomImage';
import { getCDNImageUrl, getSeoShopUrl } from 'app/utilities/Utils';
import { Link } from 'react-router-dom';
import style from './index.module.scss';

interface exploreCardInterface {
    image: string;
    title: string;
    type: string;
    rating?: number;
    deliveryTime?: string;
    deliveryDistance?: number;
    item: any;
    history?: any;
}

const ExploreCard = ({
  item, image, title, type, rating = 0, deliveryTime, deliveryDistance,
}:exploreCardInterface) => {
  const { shopUrl } = getSeoShopUrl(
    item.country,
    item.city,
    item.locality,
    item.shopType,
    item.displayName,
    item.code,
  );

  return (
    <div className="mr-4 mr-md-0">
      <div className={style.exploreMain}>
        <div className={style.image}>
          <Link to={shopUrl} className={style.imageContainer}>
            {/* <img src={image} alt="" /> */}
            <CustomImage
              imageStyle="mw-100 mh-100"
              imageUrl={getCDNImageUrl(image)}
              imageType="PRODUCT"
              imageAlt={title}
              imageTitle={title}
            />
          </Link>
        </div>

        <div className={style.infoContainer}>
          <div className={style.title}>
            <Link to={shopUrl}>
              {title}
            </Link>
          </div>

          <div className={style.type}>{type}</div>

          <div className={style.extras}>
            <div>

              <Svg
                svg="starFilled"
            // @ts-ignore
                fill="black"
                stroke="none"
                width="12px"
              />
              <span>{rating}</span>
            </div>

            <div>
              <Svg
                svg="scooter"
            // @ts-ignore
                fill="black"
                stroke="black"
                width="12px"
              />
              <span>{deliveryTime}</span>
            </div>

            <div>
              {deliveryDistance?.toFixed(2)}
              {' '}
              km
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ExploreCard;
